/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react';
import { QueryCache, ReactQueryCacheProvider } from 'react-query';
import { AnalyticsContextProvider } from './src/analytics/AnalyticsContext';

import './src/styles/global.scss';

// libs
import 'focus-visible';
import 'normalize.css';

// adds portal for search overlay
const portal = document.createElement('div');
portal.id = 'portal';
document.body.appendChild(portal);

const queryCache = new QueryCache({
  defaultConfig: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export const wrapRootElement = ({ element }) => (
  <ReactQueryCacheProvider queryCache={queryCache}>
    <AnalyticsContextProvider>{element}</AnalyticsContextProvider>
  </ReactQueryCacheProvider>
);
